(function($) {
  $(window).on('load', function() { 
      $('#audiobtn').click(function(){
        if(!$('#audiobg')[0].paused){
          $('#audiobg')[0].pause();
          $('#audiobtn i').removeClass('fa-volume-up').addClass('fa-volume-off');
        }else{
          $('#audiobg')[0].play();
          $('#audiobtn i').removeClass('fa-volume-off').addClass('fa-volume-up');
        }
      });
      $('#owl-text').owlCarousel({
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        items:1,
        margin:30,
        stagePadding:30,
        smartSpeed:450,
        loop: true,
        autoplay:true,
        nav: false,
        autoplayTimeout:7000,
        autoplayHoverPause:true
    });
    $('#owl-video').owlCarousel({
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        items:1,
        smartSpeed:450,
        loop: true,
        //autoplay:true,
        nav: false
        //autoplayTimeout:7000,
        //autoplayHoverPause:true
    });
    
    var $grid = $('.grid').masonry({
        itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
        columnWidth: '.grid-sizer',
        percentPosition: true
    });

  });
})( jQuery );
